// extracted by mini-css-extract-plugin
export default {"bodyFooter":"Footer_bodyFooter__uJ9x8","icons":"Footer_icons__JmEv+","copyright":"Footer_copyright__PY84l"};